/**
 * Maps a Kanban board's per-status colour to the semantic token index.css
 * declared for it (Cortex Console Design System & Consistency Pass, CCDS-08).
 * A status this map does not name (e.g. the Agents board's "complete" column,
 * which carries no dedicated semantic token) falls back to no accent colour -
 * never a hardcoded hex.
 */

export type KanbanBoardKind = "agents" | "review";

const AGENTS_STATUS_TOKENS: Record<string, string> = {
  running: "--kanban-running",
  blocked: "--kanban-blocked",
  ready_for_review: "--kanban-ready-for-review",
  silent: "--kanban-silent",
};

const REVIEW_STATUS_TOKENS: Record<string, string> = {
  building: "--kanban-building",
  waiting_on_person: "--kanban-waiting-on-person",
  ready_to_integrate: "--kanban-ready-to-integrate",
  closed: "--kanban-closed",
};

export function kanbanStatusToken(
  board: KanbanBoardKind,
  status: string,
): string | undefined {
  const map = board === "agents" ? AGENTS_STATUS_TOKENS : REVIEW_STATUS_TOKENS;
  return map[status];
}
